<script>
/**
 * Status tables
 */
import VProjectActionForm from "@/components/Forms/VProjectActionForm.vue";
import VProjectActionTaskForm from "@/components/Forms/VProjectActionTaskForm.vue";
import VProjectActionCategoryForm from "@/components/Forms/VProjectActionCategoryForm.vue";
import ProjectActionService from "@/services/ProjectActionService";
import Messages from "@/mixins/Messages";
import { EventBus } from "@/libraries/EventBus";
import { mapGetters } from "vuex";
import ProjectActionCategoryService from "@/services/ProjectActionCategoryService";
import VInlineEdit from "./VInlineEdit.vue";
// How many results per page
const PAGINATE_FETCH = "9999";

export default {
    props: {
        category: {
            type: String
        },
        categoryId: {},
        projectId: {},
        projectMomId: {},
        search: {},
        displayClosedActions: {
            type: Boolean,
            default: true,
            required: false
        },
        isPm: {
            type: Boolean,
            default: false
        },
        isFirst: {},
        isLast: {},
        showIDCol: {
            type: Boolean,
            default: true
        },
        filter: {}
    },
    components: {
        VProjectActionForm,
        VInlineEdit,
        VProjectActionCategoryForm,
        VProjectActionTaskForm
    },
    mixins: [Messages],
    data() {
        return {
            catHover: false,
            loading: true,
            items: [],
            meta: {},
            showModal: false,
            showTaskModal: false,
            context: {},
            initStatus: {},
            open: true,
            suSaving: false,
            suError: "",
            showModalCategory: false,
            categoryName: "",
            contextLink: ""
        };
    },
    computed: {
        ...mapGetters("auth", ["getMyId"])
    },
    watch: {
        search: function(n) {
            this.fetchData();
        },
        filter: function(n) {
            this.fetchData();
        }
    },
    async created() {
        EventBus.$on("project-actions-reload-status", this.fetchData);
        EventBus.$on("project-actions-jump-status", this.jump);
        this.apiPaginator.sort = "created";
        this.apiPaginator.direction = "desc";
        this.apiPaginator.limit = PAGINATE_FETCH;

        EventBus.$on("project-actions-reload", this.fetchData);
        this.categoryName = this.category;

        await this.fetchData();
        this.open = this.initStatus.is_open;
        this.loading = false;
    },
    beforeDestroy() {
        EventBus.$off("project-actions-reload");
        EventBus.$off("project-actions-reload-status");
        EventBus.$off("project-actions-jump-status");
    },
    methods: {
        async jump({ target_id, action_category_id, page }) {
            console.log("JKUMPO", target_id, action_category_id);

            if (parseInt(this.categoryId) === parseInt(action_category_id)) {
                try {
                    const params = {
                        id: target_id,
                        limit: PAGINATE_FETCH,
                        project_id: this.projectId,
                        action_category_id: action_category_id,
                        action_type: "1",
                        paginate: "yes",
                        filter: "all"
                    };
                    const { data } = await ProjectActionService.GET_findPage(
                        params
                    );
                    await this.fetchData({
                        sort: "created",
                        direction: "desc",
                        limit: "5",
                        page: page,
                        action_category_id: this.categoryId,
                        action_type: "1"
                    });

                    this.$nextTick(() => {
                        const row = document.querySelector(
                            `tr[data-id="${target_id}"]`
                        );
                        if (row) {
                            row.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                            row.classList.add("highlight-flash");
                            setTimeout(
                                () => row.classList.remove("highlight-flash"),
                                5000
                            );
                        }
                    });
                    // if (data.data.found)
                } catch (e) {
                    console.log("jump e", e);
                }
            }
        },
        executeJump(target_id) {
            EventBus.$emit("project-actions-jump-task", { target_id });
        },
        categoryRenamed({ name }) {
            this.categoryName = name;
            this.showModalCategory = false;
        },
        async fetchData(replaceParams = null) {
            try {
                let params = this.$buildParams();
                params["project_id"] = this.projectId;
                params["action_category_id"] = this.categoryId;
                params["action_type"] = "1";
                if (this.projectMomId) {
                    params["project_mom_id"] = this.projectMomId;
                } else {
                    params["context"] = "datatab";
                }

                if (this.filter != "all") {
                    params["filter"] = this.filter;
                }

                const { data } = await ProjectActionService.GET(params);
                this.items = data.data;
                this.meta = data.meta;
                this.initStatus = data.meta.status;
            } catch (e) {
                console.log("fd e", e);
            }
        },
        /**
         * Force fetching of everything
         */
        async loadAll() {
            this.apiPaginator.limit = 9999;
            this.fetchData();
        },
        async updateText(item, new_text) {
            try {
                this.suSaving = true;
                this.suError = "";
                const data = {
                    id: item.id,
                    notes: new_text
                };

                await ProjectActionService.PUT(data);
                await this.fetchData();
            } catch (e) {
                console.log("E updateText", e);
                this.suError = e.response.data.errors;
            }

            this.suSaving = false;
        },
        closeReload() {
            EventBus.$emit("project-actions-reload-task");
            this.showModal = false;
            this.showTaskModal = false;
            this.fetchData();
        },
        edit(ctx) {
            this.context = ctx;
            this.showModal = true;
        },
        changeActionStatus(item) {
            this.$askDeleteQuestion(
                item.status === 1
                    ? this.$t("project_actions.change_status_open")
                    : this.$t("project_actions.change_status_closed"),
                async () => {
                    await ProjectActionService.PUT({
                        id: item.id,
                        status: item.status === 1 ? 0 : 1
                    });
                    await this.fetchData();
                }
            );
        },
        async catMove(dir) {
            try {
                await ProjectActionCategoryService.PUT_move(
                    this.categoryId,
                    dir
                );
                this.$emit("refresh-after-move");
            } catch (e) {
                console.log("EX catmove", e);
            }
        },
        async deleteCategory() {
            this.$swal({
                icon: "warning",
                text: this.$t(
                    "project_actions.swal_delete_category_with_all_statuses"
                ),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    await this.doDelete();
                }
            });
        },
        async doDelete() {
            try {
                await ProjectActionCategoryService.DELETE(this.categoryId);
                this.$emit("refresh-after-move");
            } catch (e) {
                console.log("EX del", e);
            }
        },
        createTask(item) {
            this.contextLink = item.id;
            this.showTaskModal = true;
        }
    }
};
</script>

<template>
    <div class="v-project-action-table">
        <div
            class="d-flex align-items-center mb-2"
            @mouseenter="catHover = true"
            @mouseleave="catHover = false"
        >
            <h3
                class="ml-4 mb-0"
                :class="{ 'm-click': initStatus.total > 0 }"
                @click="open = !open"
            >
                {{ categoryName }}
            </h3>
            <div v-if="catHover">
                <i
                    v-if="initStatus.total > 0"
                    @click="open = !open"
                    :class="{ 'fa-toggle-on': open, 'fa-toggle-off': !open }"
                    class="far fa-fw fa-lg m-click ml-1 text-primary mr-2"
                ></i>
                <i
                    v-if="!isFirst"
                    @click="catMove('up')"
                    class="ml-2 mr-2 fa-lg fa-fw fas fa-arrow-up m-click text-primary"
                ></i>
                <i
                    @click="catMove('down')"
                    v-if="!isLast"
                    class="ml-2 mr-2 fa-lg fa-fw fas fa-arrow-down m-click text-primary"
                ></i>
                <span
                    @click="showIDCol = !showIDCol"
                    class="m-click text-primary ml-2 mr-2"
                    ><i
                        class="fas fa-lg fa-fw"
                        :class="{
                            'fa-eye': showIDCol,
                            'fa-eye-slash': !showIDCol
                        }"
                    ></i>
                    ID</span
                >
            </div>
            <div class="ml-auto mr-5" v-if="catHover && isPm">
                <i
                    class="fa fa-lg fa-fw fa-pencil m-click mr-3 text-primary"
                    @click="showModalCategory = true"
                ></i>
                <i
                    class="fa fa-lg fa-fw fa-trash text-danger m-click"
                    @click="deleteCategory"
                ></i>
            </div>
        </div>

        <v-loader :loading="loading" v-if="loading" />
        <div v-else-if="!items.length">
            <div class="mx-4 mt-3 mb-2 small text-warning text-bold">
                <i class="far fa-exclamation-triangle"></i>
                {{ $t("project_actions.no_statuses") }}
            </div>
            <base-button
                type="link"
                class="mx-3 mb-5"
                size="sm"
                @click="edit({ empty: true })"
                ><i class="far fa-plus"></i>
                {{ $t("project_actions.add_status") }}</base-button
            >
        </div>
        <template v-else-if="open">
            <v-table class="table table-mg table-sm ">
                <v-thead>
                    <v-tr>
                        <v-th v-show="showIDCol" v-if="false">
                            <v-sorter
                                :paginator="apiPaginator"
                                name="id"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_id") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="apiPaginator"
                                name="created"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_date") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="apiPaginator"
                                name="notes"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_description") }}
                            </v-sorter>
                        </v-th>
                        <v-th>
                            <v-sorter
                                :paginator="apiPaginator"
                                name="user_id"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_added_by") }}
                            </v-sorter>
                        </v-th>
                        <v-th v-if="false">
                            <v-sorter
                                :paginator="apiPaginator"
                                name="due_date"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_due") }}
                            </v-sorter>
                        </v-th>
                        <v-th style="text-align: center;" v-if="false">
                            <v-sorter
                                :paginator="apiPaginator"
                                name="status"
                                @sort="$handleSorting($event)"
                                >{{ $t("project_actions.hdr_status") }}
                            </v-sorter>
                        </v-th>
                        <v-th class="text-center">{{
                            $t("project_actions.hdr_task")
                        }}</v-th>
                        <v-th></v-th>
                    </v-tr>
                </v-thead>

                <v-tbody>
                    <v-tr
                        v-for="item in items"
                        :key="item.id"
                        :id="'action-' + item.id"
                        :data-id="item.id"
                        v-if="
                            displayClosedActions ||
                                (!displayClosedActions && item.status !== 1)
                        "
                    >
                        <v-td class="hdr__id" v-show="showIDCol" v-if="false">
                            {{ item.project_id }}-C{{
                                item.action_category_id
                            }}-{{ item.id }}
                        </v-td>
                        <v-td class="hdr__date">
                            {{ $d(new Date(item.created), "short") }}
                        </v-td>
                        <v-td class="hdr__description preserve-newlines">
                            <div class="d-flex">
                                <v-inline-edit
                                    style="flex-grow: 10"
                                    :text="item.notes"
                                    @save="updateText(item, $event)"
                                    :saving="suSaving"
                                    :error="suError"
                                />
                            </div>
                        </v-td>
                        <v-td class="hdr__user">
                            {{ item.user.name }}
                        </v-td>
                        <v-td class="hdr__date" v-if="false">
                            <template v-if="item.due_date">
                                {{ $d(new Date(item.due_date), "short") }}
                            </template>
                        </v-td>
                        <v-td
                            style="text-align: center;"
                            class="hdr__status"
                            v-if="false"
                        >
                            <template v-if="item.action_type == 2">
                                <i
                                    @click="changeActionStatus(item)"
                                    :class="{
                                        'status-closed': item.status === 1
                                    }"
                                    class="status-icon far fa-lg fa-check-circle"
                                ></i>
                            </template>
                            <template v-else>---</template>
                        </v-td>
                        <v-td class="hdr__actionlink text-center">
                            <div
                                v-if="'linked_action' in item"
                                class="m-click"
                                @click="executeJump(item.linked_action_id)"
                            >
                                {{ item.linked_action.serial_number }}
                                <i class="far fa-link fa-fw fa-lg"></i>
                            </div>
                            <template v-else>
                                <i
                                    class="far fa-plus fa-fw fa-lg m-click"
                                    @click="createTask(item)"
                                ></i> </template
                        ></v-td>
                        <v-td class="hdr__action">
                            <i
                                class="far fa-pencil fa-lg m-click"
                                @click="edit(item)"
                            ></i>
                        </v-td>
                    </v-tr>
                </v-tbody>
            </v-table>
            <div class="mt-1 mb-5">
                <base-button
                    type="link"
                    class="mx-3"
                    size="sm"
                    @click="edit({ empty: true })"
                    ><i class="far fa-plus"></i>
                    {{ $t("project_actions.add_status") }}</base-button
                >

                <base-button
                    v-if="meta.pagination.total_pages > 1"
                    type="link"
                    class="mx-3"
                    size="sm"
                    @click="loadAll"
                    ><i class="far fa-eye"></i>
                    {{ $t("project_actions.load_all") }}</base-button
                >

                <div class="paginator" v-if="meta.pagination.total_pages > 1">
                    <base-pagination
                        :page-count="meta.pagination.total_pages"
                        :per-page="meta.pagination.per_page"
                        :value="meta.pagination.current_page"
                        @input="$handlePagination($event)"
                    />
                </div>
            </div>
        </template>
        <template v-else-if="!open">
            <div class="mx-4 small text-muted mb-4">
                {{ $t("project_actions.this_category_is_hidden") }}
            </div>
        </template>
        <portal to="modals">
            <v-project-action-form
                v-if="showModal"
                :context="context"
                :project-id="projectId"
                :project-mom-id="projectMomId"
                :project-action-category-id="categoryId"
                @close-reload="closeReload"
                @close="showModal = false"
            />
            <v-project-action-category-form
                v-if="showModalCategory"
                :project-action-category-id="categoryId"
                :project-id="projectId"
                :project-mom-id="projectMomId"
                @close="showModalCategory = false"
                @close-renamed="categoryRenamed"
            />
            <v-project-action-task-form
                v-if="showTaskModal"
                :context="{ empty: true }"
                :project-id="projectId"
                :project-mom-id="projectMomId"
                :link-to-status="contextLink"
                @close-reload="closeReload"
                @close="showTaskModal = false"
            />
        </portal>
        <hr class="mt-0 pt-0" />
    </div>
</template>

<style scoped>
.status-icon {
    color: #ddd;
}

.status-closed {
    color: rgb(120, 158, 107);
}

.preserve-newlines {
    white-space: pre-line;
}
</style>

<style lang="scss">
.v-project-action-table {
    .hdr__id {
        width: 140px;
    }

    .hdr__date {
        width: 110px;
    }

    .hdr__user {
        width: 200px;
    }

    .hdr__status {
        width: 100px;
    }

    .hdr__action {
        width: 100px;
    }

    .hdr__actionlink {
        width: 120px;
    }
}
</style>
